import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Globals} from '.././globals';
import * as CryptoJS from 'crypto-js';


@Injectable()
export class AdvertisementService {
  adv:any;
  constructor(private http: HttpClient,private _global:Globals) { }

  readonly rootUrl = this._global.siteUrl;

  // add advertisement
addadvertisement(advObj, advId){
  
  const body = {
    data: advObj,
    id:advId,
  }
  
  return this.http.post(this.rootUrl + 'advertisement/addadvertisement', body);
}

updateadvertisement(advObj){
  const body = {
    advObj: advObj   
  }
  return this.http.post(this.rootUrl + 'advertisement/addadvertisement', body);
}

//editget advertisement
editgetadvertisement(advID){
  return this.http.get(this.rootUrl+"advertisement/addadvertisement?id="+btoa(advID))
}

// get advertisement 
getadvertisementlist(Obj){
  var reqHeader = new HttpHeaders({'No-Auth':'False'});
  return this.http.post(this.rootUrl + 'advertisement/getadvertisementlist', Obj,{ headers: reqHeader});
}

//del advertisement
deladvertisement(advId){
  var reqHeader = new HttpHeaders({'No-Auth':'False'});
  return this.http.post(this.rootUrl + 'advertisement/deleteadvertisement', advId,{ headers: reqHeader});
}

//del advertisement
streamlist(streamId){
  //var reqHeader = new HttpHeaders({'No-Auth':'False'});
  //return this.http.post(this.rootUrl + 'session/getstreamtypelist', sId,{ headers: reqHeader});
  return this.http.get(this.rootUrl+'session/getstreamtypelist?cid='+btoa(streamId));
}

// get advertisement 
getrandomadvlist(Obj){ 
  var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
  return this.http.post(this.rootUrl + 'advertisement/getRandomAdvList', Obj,{ headers: reqHeader});
}


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/advertisement.service.ts